<template>
    <div class="order-page-container">
        <div style="background:#f5f5f5;padding:10px">

            <!-- CARD HEADER / FILTROS -->
            <a-card :bordered="false" id="title-card">

                <template slot="title">
                    <a-breadcrumb separator=">">
                    <a-breadcrumb-item>
                        <router-link to="/cliente/monitores/cotacoes">
                        Home
                        </router-link>
                    </a-breadcrumb-item>

                    <a-breadcrumb-item class="order-page-title">
                        Monitor de Ressuprimento
                    </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>

                <template slot="extra">
                    <div class="title-actions">

                        <a-button
                            v-if="can('REQUEST', 'CREATE_RESUPPLY')"
                            @click="
                                showImportExcel = true;
                                showImportResupplyModal = true;
                            "
                        >
                            <i class="fa-solid fa-upload"></i>
                            Importar
                        </a-button>

                        <a-button
                            v-if="can('REQUEST', 'CREATE_RESUPPLY')"
                            @click="export_excel"
                            :loading="exportingExcel"
                            :disabled="exportingExcel"
                        >
                            <i v-if="!exportingExcel" class="fa-solid fa-file-excel"></i>
                            {{ exportingExcel ? 'Gerando Excel...' : 'Exportar' }}
                        </a-button>

                        <a-button
                            type="danger"
                            @click="handleLimparFiltros"
                            :hidden="!isDesktop"
                        >
                            <i class="fa-solid fa-filter-circle-xmark"></i>
                            Limpar Filtros
                        </a-button>

                        <a-button
                            type="primary"
                            @click="showDrawer"
                        >
                            <i class="fa-solid fa-filter"></i>
                            Mais Filtros
                        </a-button>

                    </div>
                </template>

                <a-row :gutter="[12, 12]">
                    <a-form layout="vertical" style="width: 100%">
                        <!-- Busca -->
                        <a-col :xs="24" :sm="12" :md="8" :lg="6">
                            <a-input-group compact class="search-group">
                                <a-select
                                    v-model="selectedSearch"
                                    class="search-group-main"
                                    allow-clear
                                    placeholder="Filtro"
                                    :dropdown-style="{ minWidth: '200px' }"
                                    style="width: 100%;"
                                >
                                    <a-select-option
                                        v-for="option in searchOptions"
                                        :key="option.key"
                                        :value="option.key"
                                    >
                                        {{ option.value }}
                                    </a-select-option>
                                </a-select>
                                <a-input
                                    v-model="search"
                                    placeholder="Buscar"
                                    allow-clear
                                    class="search-group-letter"
                                    :disabled="!selectedSearch"
                                    @pressEnter="load_resupplies"
                                />
                            </a-input-group>
                            
                        </a-col>

                        <a-col :xs="24" :sm="12" :md="8" :lg="5">
                            <a-range-picker
                                v-model="filterDateRange"
                                style="width: 100%;"
                                format="DD/MM/YYYY"
                                class="fixed-height"
                                :placeholder="['Início', 'Fim']"
                                :ranges="ranges"
                            />
                        </a-col>

                        <a-col :xs="24" :sm="12" :md="8" :lg="5">
                            <a-select
                                v-model="selectedStore"
                                placeholder="Loja"
                                allow-clear
                                mode="multiple"
                                class="fixed-height-select"
                                style="width: 100%;"
                                :dropdown-style="{ minWidth: '440px' }"
                            >
                                <a-select-option
                                    v-for="store in storesList"
                                    :key="store.value"
                                    :value="store.value"
                                >
                                    {{ store.text }}
                                </a-select-option>
                            </a-select>
                        </a-col>

                        <a-col flex="auto" class="actions-col">
                            <a-form-item class="item-button">
                                <div class="actions-right">
                                    <a-button
                                    type="default"
                                    icon="search"
                                    @click="load_resupplies"
                                    >
                                        Filtrar
                                    </a-button>
                                    <div>
                                        <AdvancedFiltersDrawer
                                            :visible.sync="visible"
                                            @apply="load_resupplies"
                                            @clear="handleLimparFiltros"
                                        >
                                            <template slot="title">
                                                <i class="fa-solid fa-filter"></i>
                                                Filtros Avançados
                                            </template>

                                            <a-form layout="vertical" hide-required-mark>

                                                <!-- Solicitação / Nome -->
                                                <a-row :gutter="16">
                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Solicitação">
                                                            <a-input
                                                                v-model="filterNumeroCotacao"
                                                                allow-clear
                                                            />
                                                        </a-form-item>
                                                    </a-col>

                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Nome da Solicitação">
                                                            <a-input
                                                                v-model="filterNomeSolicitacao"
                                                                allow-clear
                                                            />
                                                        </a-form-item>
                                                    </a-col>
                                                </a-row>

                                                <!-- Data / Produtos -->
                                                <a-row :gutter="16">
                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Data">
                                                            <a-range-picker
                                                                v-model="filterDateRange"
                                                                format="DD/MM/YYYY"
                                                                :placeholder="['Início', 'Fim']"
                                                                style="width: 100%;"
                                                                :ranges="ranges"
                                                            />
                                                        </a-form-item>
                                                    </a-col>

                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Quantidade de Produtos">
                                                            <a-input-number
                                                                v-model="filterTotalProdutos"
                                                                style="width: 100%;"
                                                            />
                                                        </a-form-item>
                                                    </a-col>
                                                </a-row>

                                                <!-- Loja / Status -->
                                                <a-row :gutter="16">
                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Loja">
                                                            <a-select
                                                                v-model="selectedStore"
                                                                placeholder="Selecione a loja"
                                                                allow-clear
                                                                mode="multiple"
                                                                show-search
                                                                optionFilterProp="children"
                                                            >
                                                                <a-select-option
                                                                    v-for="store in storesList"
                                                                    :key="store.value"
                                                                    :value="store.value"
                                                                >
                                                                    {{ store.text }}
                                                                </a-select-option>
                                                            </a-select>
                                                        </a-form-item>
                                                    </a-col>

                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Status">
                                                            <a-select
                                                                v-model="selectedStatus"
                                                                placeholder="Selecione o status"
                                                                allow-clear
                                                                mode="multiple"
                                                                show-search
                                                                optionFilterProp="children"
                                                            >
                                                                <a-select-option
                                                                    v-for="status in statusList"
                                                                    :key="status.value"
                                                                    :value="status.value"
                                                                >
                                                                    {{ status.text }}
                                                                </a-select-option>
                                                            </a-select>
                                                        </a-form-item>
                                                    </a-col>
                                                </a-row>

                                                <!-- Criador / Origem -->
                                                <a-row :gutter="16">
                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Criador">
                                                            <a-input
                                                                v-model="filterCreatedBy"
                                                                allow-clear
                                                            />
                                                        </a-form-item>
                                                    </a-col>

                                                    <a-col :xs="24" :md="12">
                                                        <a-form-item label="Origem">
                                                            <a-input
                                                                v-model="filterOrigem"
                                                                allow-clear
                                                            />
                                                        </a-form-item>
                                                    </a-col>
                                                </a-row>

                                                <!-- Observação -->
                                                <a-row :gutter="16">
                                                    <a-col :span="24">
                                                        <a-form-item label="Observação">
                                                            <a-input
                                                                v-model="filterObs"
                                                                allow-clear
                                                            />
                                                        </a-form-item>
                                                    </a-col>
                                                </a-row>

                                                <!-- Cancelados -->
                                                <a-row :gutter="16">
                                                    <a-col :span="24">
                                                        <a-form-item>
                                                            <div
                                                                class="resuply-check-container"
                                                                @click="statusFilter = !statusFilter"
                                                            >
                                                                <span
                                                                    class="material-icons-outlined"
                                                                    v-if="!statusFilter"
                                                                >
                                                                    check_box_outline_blank
                                                                </span>

                                                                <span
                                                                    class="material-icons-outlined"
                                                                    v-else
                                                                >
                                                                    check_box
                                                                </span>

                                                                Visualizar cancelados
                                                            </div>
                                                        </a-form-item>
                                                    </a-col>
                                                </a-row>

                                            </a-form>

                                        </AdvancedFiltersDrawer>
                                    </div>
                                </div>
                            </a-form-item>
                            
                        </a-col>
                    </a-form>
                    
                </a-row>

            </a-card>

        </div>

        <!-- CARD TABELA -->
        <div style="background:#f5f5f5;padding:0 10px 10px">

            <a-card
                :bordered="false"
                class="table-card"
            >

                <a-table
                    :columns="columns"
                    :data-source="resupplies"
                    size="small"
                    :pagination="pagination"
                    :row-selection="rowSelection"
                    :row-key="record => record.numeroCotacao"
                    :scroll="{ x: 'max-content' }"
                    @change="handleTableChange"
                    :locale="{
                    emptyText: 'Nenhum Pedido Encontrado.',
                    filterConfirm: 'Ok',
                    filterReset: 'Reset'
                    }"
                >

                    <!-- DATA -->
                    <template slot="data" slot-scope="text, record">
                        <div>{{ getDate(record.dataCotacao) }}</div>
                        <div>{{ getTime(record.dataCotacao) }}</div>
                    </template>

                    <!-- LOJA -->
                    <template slot="loja" slot-scope="text, record">
                    <div class="col-loja">
                        <strong :title="record.nomeLoja">
                        {{ record.nomeLoja }}
                        </strong>

                        <div v-if="isDesktop">
                        {{ formatCNPJ(record.cnpjLoja) }}
                        </div>
                    </div>
                    </template>

                    <!-- AÇÕES -->
                    <template slot="acoes" slot-scope="text, record">
                        <ActionMenu
                            :actions="getActions(record)"
                        />
                    </template>

                </a-table>
                
                <SelectionFooter
                    :count="selectedRowKeys.length"
                    item-label="solicitações selecionadas"
                    :hidden="showSendResupplyModal || showSendResupplyModalV2"
                >
                    <template #actions>
                        <a-button
                            size="large"
                            @click="clearSelection"
                        >
                            <span class="material-icons-round">
                                clear
                            </span>

                            Limpar Seleção
                        </a-button>

                        <a-button
                            v-if="can('REQUEST', 'DELETE_RESUPPLY')"
                            type="danger"
                            size="large"
                            @click="deleteQuote()"
                        >
                            <i class="fa-solid fa-trash"></i>
                            Excluir
                        </a-button>

                        <a-button
                            v-if="can('REQUEST', 'CREATE_RESUPPLY')"
                            size="large"
                            @click="mergeResupply"
                        >
                            <i class="fa-solid fa-object-group"></i>
                            Agrupar
                        </a-button>

                        <a-button
                            v-if="can('REQUEST', 'CREATE')"
                            type="primary"
                            size="large"
                            @click="sendResupply"
                        >
                            <i class="fa-solid fa-paper-plane"></i>
                            Enviar Cotação
                        </a-button>

                        <a-button
                            v-if="canExplicitly('REQUEST', 'CREATE_V2')"
                            type="primary"
                            size="large"
                            @click="sendResupplyV2"
                        >
                            <i class="fa-solid fa-paper-plane"></i>
                            Enviar Cotação (V2)
                        </a-button>
                    </template>
                </SelectionFooter>

            </a-card>

        </div>
        <ModalProductsResupply id="modal" :quotation="resupplyClick" :item="current_item"
            :closeDialog="closeProductResupply" v-if="showProductResupply" @close="closeProductResupply()"
            @loadRessuply="load_resupplies()" />
        <ModalImportExcel id="modal" @finish="importSuccess" v-if="showImportExcel && showImportResupplyModal"
            :closeDialog="closeImportResupplyModal" @close="closeImportExcel()" />
        <ModalImportNewProducts id="modal-new-products" @reload="load_resupplies()" @close="new_products = []"
            v-if="new_products && new_products.length > 0" :products="new_products" />
        <ModalSendResupply id="modal" :quotations="resupplySelect" @finish="publishSuccess()"
            v-if="showSendResupplyModal" :closeDialog="closeSendResupplyModal" @close="closeSendResuply()"
            :sendParams="sendParams" />
        <ModalSendResupplyV2 id="modal" :quotations="resupplySelect" @finish="publishSuccess()"
            v-if="showSendResupplyModalV2" :closeDialog="closeSendResupplyModalV2" @close="closeSendResupplyModalV2"
            :sendParams="sendParams" />
        <ModalChangeStore id="modal" @finish="changeStoreSuccess" :ressuply="resupplySelected"
            v-if="showModalChangeStore" @close="closeModalChangeStore()" />
        <MobileModal v-if="mobileItem" :mobileItem="mobileItem" :close="() => (mobileItem = undefined)" />
        <ModalQuotationProducts :quotation="showRequestedProductsModal" :hideExtraInfo="true"
            v-if="showRequestedProductsModal" :closeDialog="() => (showRequestedProductsModal = false)" />
        <cc-loader-full v-if="loading" />
    </div>
    
</template>
<script>
import QuotationService from "@/services/QuotationService";
import ModalProductsResupply from "@/modals/resupply-products/resupply-products.modal";
import ModalImportExcel from "@/modals/import-resupply/import-resupply.modal";
import ModalImportNewProducts from "./resupply/import-products.modal";
import ModalSendResupply from "@/modals/send-resupply/send-resupply.modal";
import ModalSendResupplyV2 from "@/modals/send-resupply-v2/send-resupply-v2.modal";
import ModalChangeStore from "@/modals/change-store/change-store.modal";
import ModalQuotationProducts from "@/modals/requested-products/requested-products.modal";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import NoDataAvailable from "@/components/utils/no-data.utils";
import StorageService from "@/services/local-storage.service";
import RequestsService from "@/services/v2/requests.service";
import { perm_mixin } from "@/mixins/permission.mixin";
import MobileNote from "@/components/notes/mobile-promotion.noteV2";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import MobileModal from "./MobileModal.vue";
import RessuplyExcelDownload from "@/services/RessuplyExcelDownload.js";
import ResupplyService from "@/services/v3/requests/resupply.service"
import RequestProductService from "@/services/v3/requests/request-products.service";
import { Breadcrumb } from "ant-design-vue";
import ActionMenu from "../../../components/popovers/action-menu.popover.vue";
import AdvancedFiltersDrawer from "../../../components/cliente/monitors/AdvancedFiltersDrawer.vue";
import SelectionFooter from "../../../components/cliente/monitors/SelectionFooter.vue";


export default {
    mixins: [perm_mixin],
    props: {
        integrationData: {
            type: Object,
            default: () => ({
                expiration_date: null,
                payment_condition: null,
                observation: null,
            }),
        },
    },
    components: {
        ModalProductsResupply,
        ModalImportExcel,
        ModalSendResupply,
        ModalSendResupplyV2,
        ModalQuotationProducts,
        ModalImportNewProducts,
        ModalChangeStore,
        "no-data-available": NoDataAvailable,
        MobileNote,
        StandardButton,
        StandardInput,
        MobileModal,
        'a-breadcrumb': Breadcrumb,
        ActionMenu,
        AdvancedFiltersDrawer,
        SelectionFooter
    },
    data() {
        return {
            ranges: {
                Hoje: [moment(), moment()],
                'Últimos 7 dias': [moment().subtract(7, "days"), moment()],
                'Últimos 30 dias': [moment().subtract(30, "days"), moment()],
                'Últimos 90 dias': [moment().subtract(90, "days"), moment()],
                'Esta Semana': [moment().startOf('week'), moment().endOf('week')],
                'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                'Mês Passado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Este Ano': [moment().startOf('year'), moment()],
                // 'Próximo Mês': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]
            },
            exportingExcel: false,
            expandedRowKeys: [],
            resupplyItems: {},
            selectedMap: {},
            isDesktop: window.innerWidth >= 720,
            showImportResupplyModal: false,
            showSendResupplyModal: false,
            showSendResupplyModalV2: false,
            loading: false,
            resupplies: [],
            listResupplies: [],
            new_products: [],
            service: new QuotationService(),
            resupply_service: new ResupplyService(),
            req_svc: new RequestsService(),
            products_service: new RequestProductService(),
            mobileItem: undefined,
            showProductResupply: false,
            showSendResuply: false,
            showImportExcel: false,
            showModalChangeStore: false,
            statusFilter: false,
            showRequestedProductsModal: undefined,
            resupplySelected: null,
            isAllCheck: false,
            current_item: null,
            storesList: [],
            selectedStore: undefined,
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'numeroCotacao',
                    key: 'numeroCotacao',
                    width: 60,
                },
                {
                    title: 'Data',
                    key: 'data',
                    scopedSlots: { customRender: 'data' },
                    width: 80,
                },                
                { title: 'Loja', scopedSlots: { customRender: 'loja' }, width: 140 },
                {
                    title: 'Nome',
                    key: 'nomeSolicitacao',
                    dataIndex: 'nomeSolicitacao',
                    width: 120,
                },
                {
                    title: 'Produtos',
                    dataIndex: 'total_produtos',
                    key: 'total_produtos',
                    width: 80,
                },
                {
                    title: 'Criador',
                    dataIndex: 'created_by',
                    key: 'created_by',
                    width: 120,
                },
                {
                    title: 'Status',
                    dataIndex: 'status_nome',
                    key: 'status_nome',
                    width: 120,
                },
                {
                    title: 'Origem',
                    dataIndex: 'origem',
                    key: 'origem',
                    width: 120,
                },
                {
                    title: 'Observação',
                    dataIndex: 'obs',
                    key: 'obs',
                    width: 120,
                },
                {
                    title: 'Ações',
                    key: 'acoes',
                    scopedSlots: { customRender: 'acoes' },
                    width: 45,
                    fixed: this.isDesktop ? 'right' : false
                },
            ],
            currentPage: 1,
            selectedRowKeys: [],
            pagination: {
                current: 1,
                pageSize: 100,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                locale: {
                items_per_page: '/ página'
                },
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
            selectedStatus: undefined,

            statusList: [
                { value: 1, text: 'ABERTA' },
                { value: 2, text: 'FECHADA' },
                { value: 3, text: 'CANCELADA' },
                { value: 4, text: 'GERADA' },
                { value: 5, text: 'PEDIDO GERADO' },
                { value: 6, text: 'DIGITADA' },
                { value: 7, text: 'NAO DIGITADA' },
                { value: 8, text: 'ENVIADA PARA CENTRAL' },
                { value: 9, text: 'COTACAO DESCARTADA' },
                { value: 10, text: 'CONGELADA' },
                { value: 11, text: 'SEM PEDIDOS PARA VOCE' },
                { value: 12, text: 'DIGITADA' },
                { value: 13, text: 'EXCLUIDO' }
            ],
            selectedSearch: undefined,
            searchOptions: [{key: 'cot_id_like', value: 'ID da Requisição'},{key: 'cot_nome_solicitacao', value: 'Nome da Requisição'}],
            search: undefined,
            filterDateRange: [],
            filterNumeroCotacao: undefined,
            filterNomeSolicitacao: undefined,
            filterTotalProdutos: undefined,
            filterCreatedBy: undefined,
            filterOrigem: undefined,
            filterObs: undefined,
            visible: false,
        };
    },
    watch: {
        statusFilter() {
            this.currentPage = 1;
            this.load_resupplies();
        },
    },
    methods: {
        getActions(record) {
            return [
                {
                    label: 'Alterar Empresa',
                    icon: 'sync_alt',
                    iconClass: 'action-info',
                    visible: this.can('REQUEST', 'UPDATE_RESUPPLY'),
                    onClick: () => this.showChangeStore(record)
                },
                {
                    label: 'Editar',
                    icon: 'edit',
                    iconClass: 'action-warning',
                    visible: this.can('REQUEST', 'UPDATE_RESUPPLY') || record.status == 15,
                    onClick: () => this.editClick(record)
                },
                {
                    label: 'Lista Mobile',
                    icon: 'phone_iphone',
                    iconClass: 'action-success',
                    visible: record.list_ids.length > 0,
                    onClick: () => {
                        this.mobileItem = record;
                    }
                },
                {
                    label: 'Listar Produtos',
                    icon: 'inventory_2',
                    iconClass: 'action-success',
                    onClick: () => {
                        this.showRequestedProductsModal = record.numeroCotacao;
                    }
                },
                {
                    label: 'Exportar Lista de produtos como Excel',
                    icon: 'upload_file',
                    iconClass: 'action-success',
                    onClick: () => this.downloadProductsExcel(record)
                },
                {
                    label: 'Exportar Lista de produtos como PDF',
                    icon: 'print',
                    iconClass: 'action-danger',
                    onClick: () => this.downloadProductsPDF(record)
                },
                {
                    label: 'Gerar Excel',
                    icon: 'folder',
                    iconClass: 'action-teal',
                    visible: this.can('REQUEST', 'UPDATE_RESUPPLY') && record.status == 15,
                    onClick: () => this.createExcel(record)
                },
                { divider: true, visible: this.can('REQUEST', 'DELETE_RESUPPLY') },
                {
                    label: 'Excluir',
                    icon: 'delete',
                    iconClass: 'action-danger',
                    visible: this.can('REQUEST', 'DELETE_RESUPPLY'),
                    onClick: () => this.deleteQuote([record.numeroCotacao])
                }
            ];
        },
        downloadProductsPDF(record) {

            this.$swal.fire({
                title: 'Gerando PDF...',
                text: 'Aguarde enquanto o arquivo é preparado.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            const callback = (data) => {

                const file = new Blob(
                    [data],
                    { type: "application/pdf" }
                );

                const fileURL = URL.createObjectURL(file);

                const el = document.createElement('a');

                const title =
                    "produtos-cotacao-" +
                    record.numeroCotacao +
                    ".pdf";

                el.download = title;
                el.href = fileURL;
                el.click();

                setTimeout(() => {
                    window.URL.revokeObjectURL(fileURL);
                }, 100);
            };

            this.is_loading_pdf = true;

            this.products_service
                .products(
                    record.numeroCotacao,
                    {
                        export: "pdf",
                    },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => response.data)
                .then(callback)
                .catch((error) => {

                    ErrorHandlerService.handle(
                        error,
                        this.$store
                    );
                })
                .finally(() => {
                    this.is_loading_pdf = false;
                    this.$swal.close();
                });
        },
        downloadProductsExcel(record) {

            this.$swal.fire({
                title: 'Gerando Excel...',
                text: 'Aguarde enquanto o arquivo é preparado.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            this.products_service
                .products(
                    record.numeroCotacao,
                    {
                        export: 'excel',
                    },
                    {
                        responseType: 'blob',
                    }
                )
                .then(response => {

                    const url = window.URL.createObjectURL(
                        response.data
                    );

                    const link = document.createElement('a');

                    link.href = url;

                    link.download = `Produtos-${record.numeroCotacao}.xls`;

                    document.body.appendChild(link);

                    link.click();

                    document.body.removeChild(link);

                    window.URL.revokeObjectURL(url);
                })
                .catch(error => {

                    ErrorHandlerService.handle(
                        error,
                        this.$store
                    );
                })
                .finally(() => {
                    this.$swal.close();
                });
        },
        clearSelection(){
            this.selectedRowKeys = []
            this.selectedMap = {}
            this.resupplyItems = {}
            this.expandedRowKeys = []
        },
        limparFiltros(){
            this.filterDateRange = []
            this.filterNumeroCotacao = undefined
            this.filterNomeSolicitacao = undefined
            this.filterTotalProdutos =  undefined
            this.filterCreatedBy = undefined
            this.filterOrigem = undefined
            this.filterObs = undefined
            this.selectedStatus = undefined
            this.selectedStore = undefined
            this.statusFilter = false
            this.search = undefined
        },
        handleLimparFiltros(){
            this.limparFiltros()
            this.load_resupplies(1)
        },
        showDrawer() {
            this.visible = true;
        },
        getDateTime(date) {
            if (date) {
                return moment(String(date)).format("DD/MM/YYYY HH:mm");
            } else {
                return "--";
            }
        },
        getDate(date) {
            return date ? moment(date).format("DD/MM/YYYY") : "--";
        },

        getTime(date) {
            return date ? moment(date).format("HH:mm") : "--";
        },
        formatCNPJ(cnpj) {
            if (!cnpj) return "";
            cnpj = String(cnpj).padStart(14, "0");
            return cnpj
                .replace(/^(\d{2})(\d)/, "$1.$2")
                .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/\.(\d{3})(\d)/, ".$1/$2")
                .replace(/(\d{4})(\d)/, "$1-$2")
                .substring(0, 18);
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;

            this.load_resupplies(pagination.current);
        },
        filterResuplies(resupplies) {
            if (this.selectedStore) {
                const resp = [];
                for (let index = 0; index < resupplies.length; index++) {
                    const element = resupplies[index];
                    if (element.nomeLoja == this.selectedStore) resp.push(element);
                }
                return resp;
            } else return resupplies;
        },
        editClick(item) {
            this.$router.push({
                path: `/cliente/monitores/ressuprimento/editar/${item.numeroCotacao}`,
            });
            //   if (item.status == 15) {
            //     this.$store.commit("setEditResuply", item);
            //     this.$router.push("/cliente/monitores/ressuprimento/edit");
            //     return;
            //   }
            //   this.current_item = item;
            //   this.resupplyClick = item.numeroCotacao;
            //   this.showProductResupply = true;
        },
        createExcel(item) {
            this.loading = true;
            this.service.getProductsResupply(item.numeroCotacao).then((resp) => {
                let products = [];
                const formater = new Intl.NumberFormat("pt-BR", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
                resp.data.produtos.forEach((p) => {
                    p.balance =
                        (p.custo_atual || 0) *
                        (p.pro_generico == 1 ? p.quantidade : p.pro_embalagem.split(" ")[1]);
                    if (p.preco_venda && p.custo_atual)
                        p.margen = ((p.preco_venda / p.custo_atual || 0) - 1) * 100;
                    else p.margen = 0;
                    products.push([
                        p.pro_ean,
                        p.pro_descricao,
                        p.pro_embalagem.split(" ")[0],
                        p.pro_embalagem.split(" ")[1],
                        "",
                        "",
                        "",
                        p.quantidade,
                        "",
                        "",
                        p.observacao,
                        "R$ " + p.custo_atual,
                        "R$ " + p.balance,
                        "R$ " + p.preco_venda,
                        formater.format(parseFloat(p.margen)) + "%",
                        "--",
                        "--",
                    ]);
                });
                new RessuplyExcelDownload(products);
                this.loading = false;
            });
        },
        setSelectedStore(value) {
            console.log(value);
            this.selectedStore = value;
        },
        getSpecialBackground(idx) {
            if (idx % 2 != 0) return "page-table-line-special";
        },
        closeImportResupplyModal: function () {
            this.showImportResupplyModal = false;
        },
        closeSendResupplyModal: function () {
            this.showSendResupplyModal = false;
        },
        closeSendResupplyModalV2() {
            this.showSendResupplyModalV2 = false;
        },
        formatDate(date) {
            return date.slice(0, 16);
        },
        prepareResupplySelect() {
             this.resupplySelect = [...this.selectedRowKeys];
        },
        async sendResupply() {
            if (await this.prepareSendResupply()) {
                this.showSendResupplyModal = true;
            }
        },
        async sendResupplyV2() {
            if (await this.prepareSendResupply()) {
                this.showSendResupplyModalV2 = true;
            }
        },
        async prepareSendResupply() {
            this.prepareResupplySelect();
            if (this.resupplySelect.length === 0) {
                this.$swal.fire("Erro!", "Selecione uma cotação.", "error");
                return false;
            }

            const action = await this.checkForZeroQuantityProducts();

            if (action === "cancelar") {
                return false;
            }
            const isSingleQuotation = this.resupplySelect.length === 1;

            let integrationData = { ...this.integrationData };

            if (isSingleQuotation) {
                const selectedCotacao = this.resupplies.find(
                    (item) => item.numeroCotacao === this.resupplySelect[0]
                );

                if (selectedCotacao) {
                    integrationData = {
                        ttp_id: selectedCotacao.ttp_id,
                        cot_observacao: selectedCotacao.cot_observacao,
                        cot_dataExpiracao: selectedCotacao.cot_dataExpiracao,
                        ...this.integrationData,
                    };
                }
            }
            const selectedCotacao = this.resupplies.find(
                (item) => item.numeroCotacao === this.resupplySelect[0]
            );

            this.sendParams = {
                cotacoes: this.resupplySelect,
                integrationData: integrationData,
                isSingleQuotation: isSingleQuotation,
            };

            if (action === "manter") {
                this.sendParams.manter_produto_zero = true;
            }

            return true;
        },
        async checkForZeroQuantityProducts() {
            this.loading = true;
            try {
                const quototionNumbers = this.resupplySelect;
                const zeroQuantityProducts = [];
                let totalZeroQuantity = 0;

                for (const quotationNumber of quototionNumbers) {
                    const response = await this.service.getProductsResupply(quotationNumber);
                    const products = response.data.produtos;

                    const zeroProducts = products.filter((p) => p.quantidade == 0);
                    if (zeroProducts.length > 0) {
                        zeroQuantityProducts.push({
                            quotationNumber,
                            products: zeroProducts,
                        });
                        totalZeroQuantity += zeroProducts.length;
                    }
                }
                this.loading = false;

                if (zeroQuantityProducts.length > 0) {
                    return this.showZeroQuantityAlert(zeroQuantityProducts, totalZeroQuantity);
                }
                return "manter";
            } catch (error) {
                this.loading = false;
                ErrorHandlerService.handle(error, this.$store);
                return "cancelar";
            }
        },
        showZeroQuantityAlert(zeroQuantityProducts, totalZeroQuantity) {
            return new Promise((resolve) => {
                let htmlContent = `<div><p><strong>Total de produtos com quantidade 0:</strong> ${totalZeroQuantity}</p><ul>`;

                zeroQuantityProducts.forEach((item) => {
                    htmlContent += `<p><strong>Requisição ${item.quotationNumber}:</strong><ul>`;
                    htmlContent += `</ul></p>`;
                });

                htmlContent += `</ul></div>`;

                this.$swal
                    .fire({
                        title: "Produtos com quantidade 0 encontrados",
                        html: htmlContent,
                        icon: "warning",
                        showCancelButton: true,
                        showDenyButton: true,
                        confirmButtonText: "Manter produtos",
                        denyButtonText: "Excluir produtos",
                        cancelButtonText: "Cancelar",
                        denyButtonColor: "#3085d6 ",
                        confirmButtonColor: "#808080",
                        cancelButtonColor: "#d33",
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            resolve("manter");
                        } else if (result.isDenied) {
                            resolve("excluir");
                        } else {
                            resolve("cancelar");
                        }
                    });
            });
        },
        importSuccess(new_products) {
            if (new_products) {
                this.new_products = new_products.map((p) => {
                    let obj = p[Object.keys(p)[0]];
                    return {
                        cot_id: Object.keys(p)[0],
                        pro_ean: obj[0],
                        pro_descricao: obj[1],
                        pro_embalagem: `${obj[2]} ${obj[3]}`,
                        estoque: obj[4],
                        quantidade: obj[7],
                        cat_id: obj.length > 8 ? obj[8] : null,
                        pro_observacao: obj.length > 10 ? obj[10] : null,
                    };
                });
            }
            this.$swal.fire("Importado!", "Sua cotação foi importada com sucesso.", "success");
            this.load_resupplies();
        },

        changeStoreSuccess() {
            this.$swal.fire(
                "Alterado!",
                "A troca da empresa foi efetuada com sucesso.",
                "success"
            );
            this.load_resupplies();
        },
        publishSuccess() {
            this.clearSelection();
            this.$swal
                .fire("Publicado!", "Sua cotação foi publicada com sucesso.", "success")
                .then(() => this.load_resupplies())
                .then(() =>
                    this.$router.push({ name: "monitors-page", params: { tab: "cotacoes" } })
                );
        },
        closeProductResupply: function () {
            this.showProductResupply = false;
        },
        load_resupplies(page = 1) {
            this.loading = true;

            const params = {
                page,
                per_page: this.pagination.pageSize,
            };

            if (this.statusFilter) {
                params['filter[status]'] = this.statusFilter;
            }

            if (this.selectedStatus?.length) {
                params['filter[cot_status]'] = this.selectedStatus.join(',');
            }

            if (this.selectedStore?.length) {
                params['filter[cot_idLoja]'] = this.selectedStore.join(',');
            }

            if (this.filterNumeroCotacao) {
                params['filter[cot_id]'] = this.filterNumeroCotacao;
            }

            if (this.filterNomeSolicitacao) {
                params['filter[cot_nome_solicitacao]'] = this.filterNomeSolicitacao;
            }

            if (this.filterCreatedBy) {
                params['filter[creator.usu_nome]'] = this.filterCreatedBy;
            }

            if (this.filterOrigem) {
                params['filter[origin.descricao]'] = this.filterOrigem;
            }

            if (this.filterObs) {
                params['filter[cot_observacao]'] = this.filterObs;
            }

            if (this.filterTotalProdutos != null) {
                params['filter[cot_qtd_produtos]'] = this.filterTotalProdutos;
            }

            if (this.filterDateRange?.length === 2) {
                params['filter[datainicial]'] =
                    this.filterDateRange[0].format('YYYY-MM-DD');

                params['filter[datafinal]'] =
                    this.filterDateRange[1].format('YYYY-MM-DD');
            }
            if (this.selectedSearch) {
                params[
                    `filter[${this.selectedSearch.toLowerCase()}]`
                ] = this.search
            }



            this.resupply_service
                .resupply(params)
                .then((response) => response.data)
                .then((data) => {

                    this.pagination.total = data.meta.total;
                    this.pagination.pageSize = data.meta.per_page;
                    this.pagination.current = data.meta.current_page;

                    this.resupplies = data.data;

                    const storesMap = new Map(
                        this.storesList.map(store => [store.value, store])
                    );

                    this.resupplies.forEach(item => {
                        storesMap.set(item.loj_id, {
                            text: `${item.nomeLoja} - ${this.formatCNPJ(item.cnpjLoja)}`,
                            value: item.loj_id
                        });
                    });

                    this.storesList = [...storesMap.values()];

                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        checkAllResupply(e) {
            this.resupplySelect = [];
            if (e.target.checked) {
                this.resupplies.forEach((element) => {
                    this.resupplySelect.push(element.numeroCotacao);
                });
            }
        },
        closeImportExcel: function () {
            this.showImportExcel = false;
        },
        closeSendResuply: function () {
            /* this.showSendResuply = false; */
        },
        closeModalChangeStore: function () {
            this.showModalChangeStore = false;
        },
        deleteQuote: function (quotes = [...this.selectedRowKeys]) {
            if (quotes.length > 0) {
                this.$swal
                    .fire({
                        title: "Tem certeza que deseja deletar a solicitação?",
                        text: "Sua solicitação será apagada.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim, desejo deletar!",
                    })
                    .then((result) => {
                        if (result.value) {
                            this.service
                                .deletequotationresuply(quotes)
                                .then((response) => response.data)
                                .then((data) => {
                                    this.load_resupplies();
                                    this.$swal.fire(
                                        "Deletado!",
                                        "Sua soliticação foi apagada com sucesso.",
                                        "success"
                                    );
                                    this.selectedRowKeys = this.selectedRowKeys.filter((key) => !quotes.includes(key));
                                })
                                .catch((error) => {
                                    this.$swal.fire(
                                        "Erro!",
                                        "Ocorreu um erro ao realizar a ação.",
                                        "error"
                                    );
                                    ErrorHandlerService.handle(error, this.$store);
                                });
                        }
                    });
            } else {
                this.$swal.fire("Ops!", "Selecione uma cotação!", "warning");
            }
        },
        update_breadcrumbs() {
            this.$store.dispatch("set_breadcrumbs", [
                {
                    name: "Painel de Operações",
                    route: "monitors-page",
                },
                {
                    name: "Ressuprimento",
                    route: "monitors-page",
                },
            ]);
        },
        mergeResupply() {
            if (this.verifyStoreResupply()) {
                this.$swal
                    .fire({
                        title: "Tem certeza que deseja agrupar as solicitações?",
                        text: "Suas solicitações serão agrupadas.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim, desejo agrupar!",
                        input: "text",
                        inputLabel: "Informe o título da solicitação",
                        inputPlaceholder: "Digite um título para a solicitação",
                    })
                    .then((result) => {
                        if (result.value) {
                            this.service
                                .mergequotationresuply(this.resupplySelect, result.value)
                                .then((response) => response.data)
                                .then((data) => {
                                    this.clearSelection();

                                    this.load_resupplies();

                                    this.$swal.fire(
                                        "Agrupado!",
                                        "Suas solicitações foram agrupadas com sucesso.",
                                        "success"
                                    );
                                })
                                .catch((error) => {
                                    this.$swal.fire(
                                        "Ops!",
                                        "Ocorreu um erro! Selecione apenas cotacoes da mesma loja e tente novamente!",
                                        "error"
                                    );
                                    ErrorHandlerService.handle(error, this.$store);
                                });
                        }
                    });
            } else {
                this.$swal.fire("Ops!", "Selecione solicitações da mesma loja!", "warning");
            }
        },
        verifyStoreResupply() {
            let list = this.resupplies.filter(r =>
                this.selectedRowKeys.includes(r.numeroCotacao)
            );

            let uniqueStore = [...new Set(list.map(item => item.loj_id))];

            return this.selectedRowKeys.length > 0 && uniqueStore.length === 1;
        },
        showChangeStore(ressuply) {
            this.resupplySelected = ressuply;
            this.showModalChangeStore = true;
        },
        updatePage(event) {
            this.pagination.current = event;
            this.load_resupplies();
        },
        async export_excel() {
            const result = await this.$swal.fire({
                title: 'Exportar Excel?',
                text: 'Será gerado um arquivo Excel com os filtros atualmente aplicados.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Exportar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true,
            });

            if (!result.isConfirmed) {
                return;
            }

            this.$swal.fire({
                title: 'Gerando arquivo...',
                text: 'Aguarde alguns instantes.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });
            this.exportingExcel = true;

            const params = {export: "excel"};

            if (this.statusFilter) {
                params['filter[status]'] = this.statusFilter;
            }

            if (this.selectedStatus?.length) {
                params['filter[cot_status]'] = this.selectedStatus.join(',');
            }

            if (this.selectedStore?.length) {
                params['filter[cot_idLoja]'] = this.selectedStore.join(',');
            }

            if (this.filterNumeroCotacao) {
                params['filter[cot_id]'] = this.filterNumeroCotacao;
            }

            if (this.filterNomeSolicitacao) {
                params['filter[cot_nome_solicitacao]'] = this.filterNomeSolicitacao;
            }

            if (this.filterCreatedBy) {
                params['filter[creator.usu_nome]'] = this.filterCreatedBy;
            }

            if (this.filterOrigem) {
                params['filter[origin.descricao]'] = this.filterOrigem;
            }

            if (this.filterObs) {
                params['filter[cot_observacao]'] = this.filterObs;
            }

            if (this.filterTotalProdutos != null) {
                params['filter[cot_qtd_produtos]'] = this.filterTotalProdutos;
            }

            if (this.filterDateRange?.length === 2) {
                params['filter[datainicial]'] =
                    this.filterDateRange[0].format('YYYY-MM-DD');

                params['filter[datafinal]'] =
                    this.filterDateRange[1].format('YYYY-MM-DD');
            }
            if (this.selectedSearch) {
                params[
                    `filter[${this.selectedSearch.toLowerCase()}]`
                ] = this.search
            }
            this.resupply_service
                .resupply(params, { responseType: 'blob' })
                .then(response => {

                    const blob = new Blob(
                        [response.data],
                        {
                            type: 'application/vnd.ms-excel'
                        }
                    );

                    const url = URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;

                    a.download = `ressuprimento-${new Date().toISOString().slice(0,10)}.xls`;

                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    URL.revokeObjectURL(url);

                    this.$message.success('Exportação concluída.');
                })
                .catch(() => {
                    this.$message.error('Erro ao exportar arquivo.');
                })
                .finally(() => {
                    this.exportingExcel = false;
                    this.$swal.close();
                });
        },
         onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        }
    },
    computed: {
        resupplySelect(){
            return this.selectedRowKeys
        },
        rowSelection() {
            return {
                selectedRowKeys: this.selectedRowKeys,
                onChange: this.onSelectChange,
            };
        },
        screenWidth(){
            return window.innerWidth;
        },
    },
    created() {
        this.load_resupplies();
        this.update_breadcrumbs();
    },
};
</script>
<style lang="scss" scoped>
td {
    padding: 0 !important;
}
.search-group {
    display: flex !important;
    width: 100%;
}


.search-group-input {
    flex: 1;
    min-width: 0;
}

.search-group .ant-select,
.search-group .ant-input-affix-wrapper,
.search-group .ant-input {
    width: 100%;
}

.search-group .ant-input-affix-wrapper {
    border-left-width: 0 !important;
}

.search-group .ant-select-selector,
.search-group .ant-input-affix-wrapper,
.search-group .ant-input {
    height: 32px !important;
}

.search-group .ant-input {
    height: 30px !important;
}
.resupply-footer {
    position: fixed;
    left: 50%;
    bottom: 14px;
    transform: translateX(-50%);
    z-index: 999;

    width: calc(100% - 32px);
    max-width: 70vw;

    background: #22252a;
    border-radius: 10px;

    padding: 8px 16px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;

    box-shadow:
        0 8px 24px rgba(0, 0, 0, 0.24),
        0 2px 8px rgba(0, 0, 0, 0.16);
}

.resupply-footer-left {
    display: flex;
    align-items: center;
    gap: 16px;

    color: #ffffff;
}

.resupply-footer-info {
    font-size: 0.74rem;
    color: rgba(255, 255, 255, 0.68);
}

.resupply-footer-count {
    font-size: 0.9rem;
    font-weight: 700;
    color: #ffffff;
}

.resupply-footer-total {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.84);
}

.resupply-footer-total strong {
    color: #ffffff;
    font-size: 0.9rem;
}

.resupply-footer-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.resupply-footer-right .ant-btn {
    height: 34px;
    padding: 0 16px;

    display: flex;
    align-items: center;
    gap: 6px;

    border: 0;
    border-radius: 8px;

    

    font-size: 0.8rem;
    font-weight: 600;

    transition: all 0.2s;
}

.create_button {
    background: #ff432d;
    color: #ffffff;
}

.resupply-footer-right .ant-btn:hover,
.resupply-footer-right .ant-btn:focus {
    background: #ff5a47;
    color: #ffffff;
}
#title-card ::v-deep .ant-card-head {
    display: flex;
    align-items: center;
}

#title-card ::v-deep .ant-card-head-wrapper {
    width: 100%;
}

#title-card ::v-deep .ant-card-extra {
    max-width: 60%;
}

.title-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 4px;
}
.actions-col {
  display: flex;
  align-items: flex-end;
}

.actions-right {
  margin-left: auto;
  display: flex;
  gap: 8px;
  margin-left: auto;
  justify-content: flex-end;
}
.page-route-select {
    display: flex;
    align-items: center;
}

.page-route-select-text {
    font-weight: 400;
    font-size: 1.36em;
    color: #ababab;
    margin-right: 20px;
    cursor: pointer;
}

.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}

.page {
    font-size: 1rem;
}

.page-title {
    font-weight: 700;
    font-size: 2.72em;
    letter-spacing: 0.15px;
    color: #605f5f;
    margin-top: 40px;
}

.mobile {
    display: none;
}

.page-buttons-containear {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    gap: 12px;
}

.store-filter {
    flex: 1;
    min-width: 250px;
    max-width: 400px;
}

.button-icon {
    color: var(--primary-color);
    margin-right: 1vw;
    font-size: 2.55em;
}

.table-header {
    margin-top: 6vh;
    margin-bottom: 1.5vh;
    border: 0.5px solid #e5e5e5;
    padding: 1vh 0;
    display: flex;
    align-items: center;
}

.table-colum-align {
    padding-left: 2vw;
}

.date-width {
    width: 15%;
}

.request-width {
    width: 15%;
}

.product-width {
    width: 15%;
}

.actions-width {
    width: 15%;
}

.suplier-width {
    flex: 1;
    text-align: left;
    margin-left: 3vw;
}

.table-row-separator {
    border-right: 1px solid #dde5e9;
}

.table-header-text {
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    line-height: 17px;
    color: #605f5f;
}

.table-mobile-header {
    display: none;
}

.table-row {
    display: flex;
    align-items: center;
    margin-bottom: 2vh;
}

.table-row-text {
    font-weight: 300;
    font-size: 1rem;
    line-height: 1;
    color: #605f5f;
}

.checkbox-icon-containear {
    margin-left: 1vw;
    padding-right: 1vw;
    color: var(--primary-color);
    cursor: pointer;
    font-size: 1.5em;
}

.row-icon {
    margin-right: 1vw;
    cursor: pointer;
}

.products-icon {
    cursor: pointer;
    color: lightgreen;
}

.mobile-note-container {
    margin-top: 3vh;
    margin-right: 3vw;
}

.page-button-width {
    margin-right: 2vw;
}

.resuply-check-container {
    display: flex;
    gap: 1vw;
    cursor: pointer;
    align-items: center;
    font-weight: 600;
    font-size: 0.8rem;
    color: #202020;
}

.resuply-check-icon {
    font-size: 1rem;
    color: var(--primary-color);
}

.page-table-line-special {
    background: #f7f7f7;
}

.seemore-button-containear {
  display: flex;
  justify-content: center;

}

@media only screen and (max-width: 800px) {
    .mobile {
        display: flex;
    }

    .page-buttons-containear {
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .mobile-button-size {
        width: 44vw;
        margin-top: 2vh;
        margin-right: 2vw;
    }

    .page {
        padding: 0 1vw 3vh 0;
        font-size: 2.5vw;
    }

    .table-header {
        display: none;
    }

    .table-row {
        margin-top: 3vh;
        flex-direction: column;
        gap: 2vh;
        font-size: 1.5em;
    }

    .table-colum-align {
        width: 100%;
        flex: unset;
        display: flex;
        justify-content: space-between;
        margin-left: 0;
    }

    .table-mobile-header {
        display: flex;
        font-weight: 700;
        font-size: 1.1em;
        color: #605f5f;
        margin-bottom: 1vh;
    }

    .table-row-separator {
        border-right: none;
    }

    .mobile-check-container {
        width: 100%;
        display: flex;
        gap: 2vw;
    }

    .mobile-table-row {
        display: flex;
        justify-content: space-between;
        width: 85%;
    }

    .mobile-table-left {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .mobile-table-center {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .actions-width {
        justify-content: space-evenly;
    }

    .desktop {
        display: none;
    }
}
</style>
